var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckMark = function SvgCheckMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.257.447a.75.75 0 0 1 .046 1.06l-11 12a.75.75 0 0 1-1.083.023l-5-5a.75.75 0 1 1 1.06-1.06l4.446 4.446L16.197.493a.75.75 0 0 1 1.06-.046Z",
    fill: "#050400"
  })));
};
export default SvgCheckMark;